<div class="auth-page">
  <div class="auth-shell">
    <div class="auth-card">
      <div class="auth-brand">
        <img
          src="assets/favicon/android-chrome-192x192.png"
          [attr.alt]="'COMPONENTS.AUTH.BRAND_ALT' | translate"
          class="auth-brand-logo"
        />
        <h1 class="auth-brand-title">OrgLines</h1>
      </div>

      <form class="auth-form" [formGroup]="formModel.form" (ngSubmit)="submitForm()">
        <div>
          <label for="pwd-input" class="auth-field-label">{{ "INPUTS.PASSWORD" | translate }}</label>
          <input
            id="pwd-input"
            type="password"
            class="input-field-lg auth-input w-full"
            [placeholder]="'INPUTS.PASSWORD' | translate"
            [class.is-invalid]="(passwordFormControl.touched || passwordFormControl.dirty) && passwordFormControl.errors"
            [class.is-valid]="!passwordFormControl.errors"
            [formControlName]="formModel.fieldNames.password"
          />
          <ng-container
            *ngTemplateOutlet="
              validationErrorsTemplate;
              context: { errors: passwordFormControl.errors }
            "
          ></ng-container>
        </div>

        <div>
          <label for="confirm-pwd-input" class="auth-field-label">{{ "INPUTS.REPEAT_PASSWORD" | translate }}</label>
          <input
            id="confirm-pwd-input"
            type="password"
            class="input-field-lg auth-input w-full"
            [placeholder]="'INPUTS.REPEAT_PASSWORD' | translate"
            [class.is-invalid]="(confirmPasswordFormControl.touched || confirmPasswordFormControl.dirty) && confirmPasswordFormControl.errors"
            [class.is-valid]="!confirmPasswordFormControl.errors"
            [formControlName]="formModel.fieldNames.confirmPassword"
          />
          <ng-container
            *ngTemplateOutlet="
              validationErrorsTemplate;
              context: { errors: confirmPasswordFormControl.errors }
            "
          ></ng-container>
        </div>

        <button
          type="submit"
          class="btn-primary auth-submit w-full rounded-xl"
          [disabled]="formModel.form.invalid"
        >
          {{ "BUTTONS.CHANGE_PASSWORD" | translate }}
        </button>
      </form>
    </div>
    <p class="auth-footer-note">{{ "COMPONENTS.AUTH.FOOTER_NOTE" | translate }}</p>
  </div>
</div>

<ng-template #validationErrorsTemplate let-errors="errors">
  <ul class="invalid-feedback mt-2" *ngIf="errors">
    <li *ngIf="errors['required']">{{ "ERRORS.REQUIRED" | translate }}</li>
    <li *ngIf="errors['email']">{{ "ERRORS.EMAIL" | translate }}</li>
    <li *ngIf="errors['minlength']">
      {{
        "ERRORS.MINLENGTH"
          | translate: { requiredLength: errors["minlength"].requiredLength }
      }}
    </li>
    <li *ngIf="errors['maxlength']">
      {{
        "ERRORS.MAXLENGTH"
          | translate: { requiredLength: errors["maxlength"].requiredLength }
      }}
    </li>
    <li *ngIf="errors['hasDigit']">{{ "ERRORS.HAS_DIGIT" | translate }}</li>
    <li *ngIf="errors['hasLowerCase']">{{ "ERRORS.HAS_LOWERCASE" | translate }}</li>
    <li *ngIf="errors['hasUpperCase']">{{ "ERRORS.HAS_UPPERCASE" | translate }}</li>
    <li *ngIf="errors['hasNonAlphaNumeric']">{{ "ERRORS.HAS_NON_ALPHANUMERIC" | translate }}</li>
    <li *ngIf="errors['passwordsNotEqual']">{{ "ERRORS.PASSWORDS_NOT_MATCH" | translate }}</li>
  </ul>
</ng-template>

<app-toasts></app-toasts>

<ng-template #dangerTpl>
  {{ callbackError }}
</ng-template>

<ng-template #successTpl>
  {{ message }}
</ng-template>
